export { LoyaltyUserJourney as default } from 'pages/loyalty/loyalty-user-journey/loyalty-user-journey';
